import { Dropdown } from "react-bootstrap";
import './styles.css';

const ORDER_OPTIONS = [
    { label: "Último modificado", value: "lastModified" },
    { label: "Ordem alfabética", value: "alphabetical" },
    { label: "Últimos criados", value: "lastCreated" },
];

export default function OrderByDropdown({ style, onSelect, selectedOrder }) {
    const selectedLabel = ORDER_OPTIONS.find(opt => opt.value === selectedOrder)?.label || "Último modificado";
    return (
        <Dropdown style={{ ...style }}>
            <Dropdown.Toggle variant="dark" className="btn-sm">
                {selectedLabel}
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ backgroundColor: '#27272A'}}>
                {ORDER_OPTIONS.map(option => (
                    <Dropdown.Item key={option.value} onClick={() => onSelect(option.value)}>
                        {option.label}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}